import dayjs from "dayjs";
import "dayjs/locale/nb";
import localizedFormat from "dayjs/plugin/localizedFormat";

import React from "react";
import { Route, Routes } from "react-router-dom";
import axios from "./api/axios";
import axiosJson from "./api/axiosJson";
import config from "./config";
import Root from "./routes/Root";

import { AuthProvider, AuthRestrict } from "@tv2no/ui-react";
import "@tv2no/ui-react/dist/styles.css";

// Set dayjs locale
dayjs.locale("nb");
dayjs.extend(localizedFormat);

const App = () => {
    const handleLogin = (token) => {
        // Set token in axios request
        axios.defaults.headers["Authorization"] = `Bearer ${token}`;
        axiosJson.defaults.headers["Authorization"] = `Bearer ${token}`;
    };

    return (
        <AuthProvider onLogin={handleLogin} loginUrl={config.authUrl} appId={config.authAppId}>
            <Routes>
                <Route
                    path="/*"
                    element={
                        <AuthRestrict>
                            <Root />
                        </AuthRestrict>
                    }
                />
            </Routes>
        </AuthProvider>
    );
};

export default App;
